import { render } from "./CollectionLayoutMain.vue?vue&type=template&id=bbcfafb4"
import script from "./CollectionLayoutMain.vue?vue&type=script&lang=js"
export * from "./CollectionLayoutMain.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__